import { MutableRefObject, Ref, RefCallback } from 'react';

export default function mergeRefs<T>(
  ...refs: Array<RefCallback<T> | MutableRefObject<T | null> | null | undefined>
): Ref<T> {
  return (node) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref != null) {
        ref.current = node;
      }
    });
  };
}
